import { FC, ReactElement } from 'react';

import { ChartsValueDataTypes } from '../StatsCharts';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { formatNumber } from '@pp/core/src/utils/formatters';

import styles from './MultiplierAndPercentageView.module.css';
interface MultiplierAndPercentageViewProps {
  data: ChartsValueDataTypes;
}

export const MultiplierAndPercentageView: FC<MultiplierAndPercentageViewProps> = ({ data: { multiplier, percentage } }): ReactElement => {
  const locale = useSettingsSlice.currentLanguage();
  const formattedMultiplier = (value: string) => {
    if(value.includes('-')){
      const temp = value.split(' - ');
      return `${formatNumber(locale, Number(temp[0].substring(0, temp[0].length-1)))}x - ${formatNumber(locale, Number(temp[1].substring(0, temp[1].length-1)))}x`
    }
  return value;
  }

  return (
    <div className={styles.charts_multiplier_percentage_box}>
      <div className={styles.charts_multiplier}>{formattedMultiplier(multiplier)}</div>
      <div className={styles.charts_percentage}>{percentage}%</div>
    </div>
  );
};
